module.exports = __webpack_public_path__ + "static/media/logo_bartholomeus_gasthuis.cfd96a95.png";